import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mentoring-counselling',
  templateUrl: './component.html',
  styleUrls: ['./component.css']
})
export class MentoringCounsellingComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
